import React, { useState } from "react";

import { GetDistributorListQuery } from "../../../common/api/catalogue-api/distributors/queries/GetDistributorListQuery";
import { useDistributorsApi } from "../../../common/api/catalogue-api/distributors/useDistributorsApi";
import { DistributorsListingFilters } from "../listing/useDistributorsListingFilters";
import { DistributorListingContext } from "./DistributorListingContext";
import { DistributorListingItem, mapToDistributorListingItem } from "./DistributorsListingItem";

export type DistributorListingProviderProps = React.PropsWithChildren<unknown>;

export const DistributorListingProvider: React.FC<DistributorListingProviderProps> = (
    props: DistributorListingProviderProps
) => {
    const [items, setItems] = useState<DistributorListingItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { getDistributorsList } = useDistributorsApi();

    const getData = async (filters: DistributorsListingFilters): Promise<void> => {
        setIsLoading(true);

        const query: GetDistributorListQuery = {
            page: filters.page,
            pageSize: filters.pageSize,
            sortBy: filters.sortBy,
            sortOrder: filters.sortOrder,
            name: filters.name
        };

        const response = await getDistributorsList(query);
        const distributorItems = response.items.map(mapToDistributorListingItem);
        setItems(distributorItems);
        setTotalItems(response.totalCount);

        setIsLoading(false);
    };

    const addItem = (item: DistributorListingItem): void => {
        setItems((prevItems) => {
            return [item, ...prevItems];
        });
    };

    return (
        <DistributorListingContext.Provider
            value={{
                isLoading,
                totalItems,
                items,
                addItem,
                loadData: getData
            }}
        >
            {props.children}
        </DistributorListingContext.Provider>
    );
};
